<template>
  <div class="c-box" v-if="!loading">
    <loader :loading="sending":label="getCountVariations()"/>

    <header class="c-box__heading" v-bind:class="{disabledHeader: product.status === 'cannotSend'}" @click="toggleProductInfo()">
      <span v-once>{{ product.title }}</span>
      <i v-bind:class="toggleIconClass()" class="u-floatRight icon"></i>
      <span slot="header-right">
        <span v-if="isProductStatusNotSending" class="badge u-floatRight status" v-bind:class="product.status">{{ productStatusLabel }}</span>
        <slot name="header-right"></slot>
      </span>
    </header>

      <div class="c-box__body" v-show="show && !everyVariationWithErrorOrSent">
      <div class="c-box__inner">
        <panel v-if="product" title="Informações gerais do produto">
          <div slot="header-right">
            <button :disabled="addingImage" v-bind:class="{ 'is-loading': addingImage }" @click="addingImage = true" slot="header-actions" class="hint hint--left btn btn--info" data-label="Adicionar uma imagem em uma ou mais variações">
              Adicionar Imagem
            </button>

            <modal-add-image :visible="addingImage" :variations="product.variations" :callback="uploadedImage" v-on:close="close => addingImage = close" :module="moduleUploadImageModal"/>
          </div>
          <div class="l-row">
            <form-group label="Título" :columns="12" slot="product" :error="getError('title', product.productId)" :required="true">
              <input class="form-input" type="text" v-model="product.title" :disabled="disabledInput('title')">
              <small v-if="maxTitleLengthDI !== null" class="form-help" v-bind:class="titleLength">{{ getTitleLengthLabel() }}</small>
            </form-group>

            <form-group label="Descrição" :columns="12" slot="product" :error="getError('description', product.productId)" :required="true">
              <quill-editor  v-if="allowDescriptionHtml" :options="{ placeholder: 'Adicione a descrição do seu produto aqui' } " v-model="product.description" :disabled="disabledInput('description')"/>
              <textarea v-else class="form-textarea" rows="8" :options="{ placeholder: 'Adicione a descrição do seu produto aqui' } " v-model="product.description" :disabled="disabledInput('description')">
            </textarea>
              <small v-if="maxDescriptionLengthDI !== null" class="form-help" v-bind:class="descriptionLength">{{ getDescriptionLengthLabel() }}</small>
            </form-group>
            <slot/>
          </div>

          <div class="l-row">
            <form-group label="Marca" :columns="3" slot="product" :error="getError('brand', product.productId)" :required="true">
              <select v-model="brand" class="form-select" @change="onChangeAttribute('brand', brand)">
                <option :value=null>{{ $t('choose.label') }} </option>
                <option value="custom">Adicionar personalizada</option>
                <option v-for="brand in brands" :key="brand" :value="brand">{{ brand }}</option>
              </select>
              <br>
              <editable value="" v-if="customBrand" :isEditable="true" :onConfirm="(a, b) => onConfirmAttribute(a, b, 'brand')" :onCancel="() => onCancelAttribute('brand')"/>
            </form-group>

            <form-group :label="$t('category.label')" :error="getError('typeVariation', product.productId)" :required="true">
              <select v-model="category" class="form-select">
                <option :value=null>{{ $t('choose.label') }}</option>
                <option v-for="category in categories" :key="category" :value="category.name">{{ category.name }}</option>
              </select>
            </form-group>

            <form-group :label="$t('typeVariation.label')" :error="getError('typeVariations', product.productId)" :required="true">
              <select v-model="typeVariations" class="form-select">
                <option :value="null">Selecione</option>
                <option value="none">Sem variação</option>
                <option value="color">Cor</option>
                <option value="size">Tamanho</option>
                <option value="voltage">Voltagem</option>
                <option value="colorsize">Cor e Tamanho</option>
                <option value="colorvoltage">Cor e Voltagem</option>
                <option value="sizevoltage">Tamanho e Voltagem</option>
                <option value="colorsizevoltage">Cor, Tamanho e Voltagem</option>
              </select>
            </form-group>

            <form-group :label="$t('warranty.label')" :required="true" :error="getError('warrantyTime', product.productId)">
              <input type="number" class="form-input" v-model="product.warrantyTime">
            </form-group>
          </div>

          <div class="l-row">
            <form-group :label="$t('ncm.label')" :error="getError('ncm', product.productId)">
              <input type="number" class="form-input" v-model="product.ncm">
            </form-group>

            <form-group :label="$t('crossDocking.label')" :error="getError('crossDocking', product.productId)">
              <input type="number" class="form-input" v-model="crossDocking">
              <small class="form-help"> (Em dias)</small>
            </form-group>
          </div>

        </panel>

        <div class="divider">
          <span>Informações das variações do produto</span>
        </div>

        <div class="l-row vertical-flex">
          <div class="l-col-12@md" v-for="variation in product.variations" :key="variation">
            <component :is="marketplaceVariationProvide" ref="product.variations" :fromModule="fromModule" :toModule="toModule" :variation="variation" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import { quillEditor } from 'vue-quill-editor'
  import ModalAddImage from '@/components/marketplace/shared/provide/ModalAddImage'
  import {mapActions, mapGetters} from 'vuex'
  import api from '@/api'
  import notifier from '@/notifier'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import Loader from '@/components/template/Loader'
  import MarketplaceProvideVariationMaisCorreios from '@/components/marketplace/maisCorreios/provide/Variation'
  import Editable from '@/components/template/Editable/Base'

  export default {
    inject: ['maxDescriptionLengthDI', 'moduleDI', 'allowDescriptionHtml', 'maxTitleLengthDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'maisCorreios'
      },
      allowDescriptionHtml: true
    },
    data: () => ({
      loading: false,
      maxTitleLengthDI: 250,
      maxDescriptionLengthDI: 21000,
      categories: [],
      brands: [],
      brand: null,
      custom: [],
      customBrand: false,
      category: null,
      allowDescriptionHtml: false,
      variation: [],
      show: false,
      typeVariations: [],
      isProductStatusNotSending: false,
      productStatusLabel: '',
      addingImage: false,
      ncm: null,
      color: null,
      size: null,
      crossDocking: 0
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      },
      disabledInputList: {
        type: Array,
        default: () => []
      }
    },
    async mounted () {
      try {
        this.categories = await api.maisCorreios.getCategories()
        this.categories.sort((a, b) => a.name.localeCompare(b.name))
      } catch (err) {
        notifier.error('Não foi possível carregar as categorias da MaisCorreios.', 'Erro')
      }

      if (this.categories) {
        const presetCategorization = this.$parent.getPresetItemsCategorization(this.product.categories)
        if (presetCategorization !== null && presetCategorization !== undefined) {
          this.categories.map((category) => {
            if (category.name === presetCategorization.category) {
              this.category = presetCategorization.category
            }
          })
        }
      }

      try {
        this.brands = await api.getBrands(this.moduleDefinition.type, this.moduleDefinition.identifier)
      } catch (err) {
        notifier.error('Não foi possível carregar as marcas da MaisCorreios.', 'Erro')
      }

      if (!this.allowDescriptionHtml) {
        this.removeHtml()
      }

      this.loading = true

      this.loading = false
      this.$parent.loadingProducts(false)
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      onChangeAttribute (attributeId, value) {
        if (attributeId === 'brand') {
          if (value === 'custom') {
            this.customBrand = true
          } else {
            this.customBrand = false
          }
        }
      },
      onConfirmAttribute (oldValue, newValue, attributeId) {
        if (attributeId === 'brand') {
          this.brands.push(newValue)
          this.brand = newValue
          this.customBrand = false
        }
      },
      onCancelAttribute (attributeId) {
        if (attributeId === 'brand') {
          this.brand = null
          this.customBrand = false
        }
      },
      formatProduct () {
        this.clearErrors()

        if (this.typeVariations === null || this.typeVariations.length === 0) {
          this.addError({
            productId: this.product.productId,
            property: `typeVariations`,
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        if (this.product.warrantyTime === null || this.product.warrantyTime === '') {
          this.addError({
            productId: this.product.productId,
            property: `warrantyTime`,
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => {
            const hasColorAttribute = variation.attributes.color !== undefined && variation.attributes.color !== null && variation.attributes.color !== ''
            const hasSizeAttribute = variation.attributes.size !== undefined && variation.attributes.size !== null && variation.attributes.size !== ''
            const hasVoltageAttribute = variation.attributes.voltage !== undefined && variation.attributes.voltage !== null && variation.attributes.voltage !== ''

            const attributes = []

            if (hasColorAttribute) {
              attributes.push({
                id: 'COLOR',
                label: 'Cor',
                valueId: variation.attributes.color.code.toString(),
                valueLabel: variation.attributes.color.label
              })
            }

            if (hasSizeAttribute) {
              attributes.push({
                id: 'SIZE',
                label: 'Tamanho',
                valueId: variation.attributes.size,
                valueLabel: variation.attributes.size
              })
            }

            if (hasVoltageAttribute) {
              attributes.push({
                id: 'VOLTAGE',
                label: 'Voltagem',
                valueId: variation.attributes.voltage,
                valueLabel: variation.attributes.voltage
              })
            }

            this.product.variation = {
              sku: variation.sku,
              quantity: variation.quantity,
              price: variation.price,
              ean: variation.ean,
              images: variation.images
            }

            return {
              title: this.product.title,
              sku: this.product.variation.sku,
              description: this.product.description,
              price: variation.price,
              stock: variation.stock,
              color: hasColorAttribute ? attributes.color : null,
              size: hasSizeAttribute ? attributes.size : null,
              ean: this.typeVariations === 'none' ? variation.ean : this.product.ean,
              weight: variation.weight,
              width: variation.width,
              height: variation.height,
              length: variation.length,
              warranty: this.product.warrantyTime ? this.product.warrantyTime : 0,
              ncm: this.product.ncm,
              brand: this.brand,
              category: this.category,
              typeVariations: this.typeVariations,
              variation: this.product.variation,
              crossDocking: {
                quantity: this.crossDocking
              },
              images: variation.images.length ? variation.images : null,
              source: this.fromModule,
              attributes: attributes,
              original: {
                product: this.product,
                variation: variation
              },
              productId: this.product.productId
            }
          }
        )
      },
      disabledInputs () {
        return this.product.status === 'sent' || this.product.status === 'error'
      },
      removeHtml () {
        const doc = new DOMParser().parseFromString(this.product.description, 'text/html')
        let text = doc.body.innerText || doc.body.textContent || ''

        text = text
          .replace(/\r\n/g, '\n')
          .replace(/\r/g, '\n')
          .replace(/\n{3,}/g, '\n\n')
          .trim()

        this.product.description = text
      },
      getDescriptionLengthLabel () {
        return `${this.product.description.length}/${this.maxDescriptionLengthDI}`
      },
      getTitleLengthLabel () {
        return `${this.product.title.length}/${this.maxTitleLengthDI}`
      },
      getCountVariations () {
        const selectedVariations = this.product.variations
          .filter(variation => variation.selected)

        const sentVariations = selectedVariations
          .filter(variation => variation.status !== 'sending')
          .length

        return `${sentVariations}/${selectedVariations.length} variações enviadas`
      },
      uploadedImage (urls, variations) {
        for (let i in variations) {
          const sku = variations[i].sku
          const variation = this.product.variations.find(variation => variation.sku === sku)

          if (variation === undefined) {
            continue
          }

          for (let j in urls) {
            variation.images.push(urls[j])
          }
        }

        variations.splice(0, variations.length)
      },
      disabledInput (input) {
        if (!this.disabledInputList.length) {
          return false
        }

        return this.disabledInputList.indexOf(input) !== -1
      },
      toggleProductInfo () {
        if (this.product.status === 'sent' || this.product.status === 'error' || this.product.status === 'cannotSend') {
          return false
        }

        this.show = !this.show
      },
      toggleIconClass () {
        return {
          'icon-circle-up': this.show,
          'icon-circle-down': !this.show || this.everyVariationWithErrorOrSent
        }
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      moduleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', 'maisCorreios')
      },
      sending () {
        return !!this.product.variations
          .filter(variation => variation.status === 'sending').length
      },
      marketplaceVariationProvide () {
        return `MarketplaceProvideVariationMaisCorreios`
      },
      everyVariationWithErrorOrSent () {
        return this.product.variations.every(variation => variation.status === 'error' || variation.status === 'sent')
      },
      descriptionLength () {
        return {
          't-success': this.product.description.length <= this.maxDescriptionLengthDI,
          't-error': this.product.description.length > this.maxDescriptionLengthDI
        }
      },
      titleLength () {
        return {
          't-success': this.product.title.length <= this.maxTitleLengthDI,
          't-error': this.product.title.length > this.maxTitleLengthDI
        }
      },
      moduleUploadImageModal () {
        return {
          type: this.toModule.type,
          identifier: this.toModule.identifier
        }
      }
    },
    watch: {
      category (value) {
        this.product.category = value.code
      }
    },
    components: {
      FormGroup,
      Multiselect,
      Loader,
      Editable,
      Panel,
      quillEditor,
      ModalAddImage,
      MarketplaceProvideVariationMaisCorreios
    }
  }
</script>
<style lang="sass" scoped>
  .c-box
    margin-bottom: 16px

  .c-box__body
    background: #d9edf7

  .c-box__heading
    cursor: pointer
    height: 50px
    line-height: 2
    font-size: 15px
    color: #31708f
    background-color: #d9edf7
    border-color: #bde2fb

  .icon-circle-down, .icon-circle-up
    font-size: 30px

  .c-box__body
    border-color: #bde2fb

  .divider
    margin-bottom: 16px

  .status
    margin-right: 20px
    margin-top: 4px

  .disabledHeader
    cursor: not-allowed
    background-color:  #E7E7E7
    border-color: #D3D3D3

    .icon
      opacity: 0.3
</style>



// WEBPACK FOOTER //
// Product.vue?48ff7856